import { Component, OnInit, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PlantillasService } from '../../services/plantillas.service';
import { PlantillaDocumentoRequest, PlantillaDocumentoListResponse } from '../../models/plantilla.model';
import { ModalNotifyComponent, ModalNotifyTypes } from '../modal-notify/modal-notify.component';
import { DataTableComponent } from '../controls/data-table/data-table.component';
import { BaseServiceService } from '../../services/base-service.service';

declare var fabric: any;

@Component({
  selector: 'app-plantillas',
  templateUrl: './plantillas.component.html',
  styleUrls: ['./plantillas.component.css']
})
export class PlantillasComponent implements OnInit {

  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;
  @ViewChild(DataTableComponent) dataTableComponent!: DataTableComponent;
  @ViewChild('documentContent') documentContentRef!: ElementRef;

  // Formularios
  plantillaForm: FormGroup = new FormGroup({});
  editarForm: FormGroup = new FormGroup({});

  // Variables de estado
  plantillas: PlantillaDocumentoListResponse[] = [];
  plantillaSeleccionada: PlantillaDocumentoListResponse | null = null;
  formSubmitted = false;
  formEditSubmitted = false;
  botonProcesando = false;
  textoBotonProcesando = 'Cargando...';
  archivoSeleccionado: File | null = null;
  archivoEditSeleccionado: File | null = null;
  plantillaEditandoId: number = 0;

  // Visor de documentos
  mostrarVisor = false;
  cargandoDocumento = false;
  documentoActual = {
    id: 0,
    nombre: '',
    extension: ''
  };

  // Modales
  dialogComponentCreate: any;
  dialogComponentEdit: any;
  dialogComponentSuccess: any;

  // DataTable
  getDataTablePlantillas: any = ['PlantillaDocumento', 'GetDataTablePlantillasDocumento'];
  columnas: any[] = [];
  dtOptButtons: any = [];

  constructor(
    private fb: FormBuilder,
    private plantillasService: PlantillasService,
    private baseService: BaseServiceService,
    private renderer: Renderer2
  ) {
    this.inicializarFormularios();
    this.configurarDataTable();
  }

  ngOnInit(): void {
    this.configurarBotonesDataTable();
    this.inicializarComponentesFabric();
  }

  inicializarFormularios(): void {
    this.plantillaForm = this.fb.group({
      nombre: ['', [Validators.required, Validators.maxLength(250)]],
      descripcion: ['', [Validators.maxLength(500)]],
      activo: [true]
    });

    this.editarForm = this.fb.group({
      nombre: ['', [Validators.required, Validators.maxLength(250)]],
      descripcion: ['', [Validators.maxLength(500)]],
      activo: [true]
    });
  }

  configurarBotonesDataTable(): void {
    this.dtOptButtons.push(
      {
        "button-id": "btnView",
        "button-icon": "ms-Icon--View",
        "button-tooltip": "Ver Plantilla",
      },
      {
        "button-id": "btnEdit",
        "button-icon": "ms-Icon--EditNote",
        "button-tooltip": "Editar Plantilla",
      },
      {
        "button-id": "btnDelete",
        "button-icon": "ms-Icon--Delete",
        "button-tooltip": "Eliminar Plantilla",
      },
      {
        "button-id": "btnDownload",
        "button-icon": "ms-Icon--Download",
        "button-tooltip": "Descargar Plantilla",
      }
    );
  }

  inicializarComponentesFabric(): void {
    var checkBoxElements = document.querySelectorAll(".ms-CheckBox");
    for (var i = 0; i < checkBoxElements.length; i++) {
      new fabric["CheckBox"](checkBoxElements[i]);
    }
  }

  configurarDataTable(): void {
    this.columnas = [
      { title: "ID", data: "Id" },
      { title: "Nombre", data: "Nombre" },
      { title: "Descripción", data: "Descripcion" },
      { title: "Tipo", data: "Extension" },
      { title: "Tamaño", data: "Tamano" },
      { title: "Fecha Creación", data: "FechaCreacion" },
      { title: "Usuario Creación", data: "UsuarioCreacion" },
      {
        title: "Activo",
        data: "Activo",
        render: this.booleanColumnRenderer,
        orderable: false,
      }
    ];
  }

  booleanColumnRenderer = (data: any, type: any, row: any, meta: any) => {
    if (type === "display") {
      return `<input type="checkbox" disabled ${data ? "checked" : ""}>`;
    }
    return data;
  };

  abrirModalCrear(): void {
    this.limpiarFormularioSinConfirmacion();
    const dialog = document.querySelector(".create-plantilla");
    this.dialogComponentCreate = new fabric["Dialog"](dialog);
    this.dialogComponentCreate.open();
  }

  private limpiarFormularioSinConfirmacion(): void {
    this.plantillaForm.reset();
    this.plantillaForm.controls["activo"].setValue(true);
    this.archivoSeleccionado = null;
    this.formSubmitted = false;
    this.baseService.clearForm();
  }

  clearFormPlantilla(): void {
    this.baseService.triggerShowModal(
      "Cancelar creación de plantilla",
      "¿Seguro que desea cancelar la creación de la plantilla?",
      ModalNotifyTypes.Warning,
      true
    );

    this.modalNotifyComponent.actionConfirmed.subscribe(
      (confirmed: boolean) => {
        if (confirmed) {
          this.plantillaForm.reset();
          this.plantillaForm.controls["activo"].setValue(true);
          this.archivoSeleccionado = null;
          this.formSubmitted = false;
          this.baseService.clearForm();
          this.dialogComponentCreate.close();
        }
        // Si se cancela, no hacemos nada y el modal permanece abierto
      }
    );
  }

  onArchivoSeleccionado(event: any): void {
    const archivo = event.target.files[0];
    if (archivo) {
      this.archivoSeleccionado = archivo;
    }
  }

  crearPlantilla(): void {
    this.formSubmitted = true;

    if (this.plantillaForm.valid && this.archivoSeleccionado) {
      this.botonProcesando = true;
      this.textoBotonProcesando = 'Creando plantilla...';

      const nombre = this.plantillaForm.get('nombre')?.value;
      const descripcion = this.plantillaForm.get('descripcion')?.value || '';

      // Usar el nuevo método unificado
      this.plantillasService.crearPlantillaCompleta(nombre, descripcion, this.archivoSeleccionado)
        .then(observable => {
          observable.subscribe({
            next: (response) => {
              
              if (response.Ok) {
                this.mostrarModalExito();
                // Recargar la tabla después de crear exitosamente
                this.recargarTabla();
              } else {
                this.mostrarError('Error al crear plantilla: ' + (response.error || 'Error desconocido'));
              }
              this.botonProcesando = false;
            },
            error: (error) => {
              this.mostrarError('Error al crear plantilla: ' + error.message);
              this.botonProcesando = false;
            }
          });
        })
        .catch(error => {
          this.mostrarError('Error al procesar archivo: ' + error.message);
          this.botonProcesando = false;
        });
    } else if (!this.archivoSeleccionado) {
      this.mostrarError('Debe seleccionar un archivo');
    }
  }

  mostrarModalExito(): void {
    this.dialogComponentCreate.close();
    const dialog = document.querySelector(".modal-success");
    this.dialogComponentSuccess = new fabric["Dialog"](dialog);
    this.dialogComponentSuccess.open();
  }

  cerrarModal(): void {
    if (this.dialogComponentSuccess) {
      this.dialogComponentSuccess.close();
    }
    // Recargar la tabla usando el método correcto
    this.recargarTabla();
  }

  recargarTabla(): void {
    // Recargar los datos de la tabla usando el método correcto del DataTableComponent
    if (this.dataTableComponent) {
      this.dataTableComponent.ReloadGrid(this.dataTableComponent.dtElement, 'datatablePlantillas');
    }
  }

  gridLoaded(event: any): void {
    // Este método se llama cuando se carga la grilla
    // Aquí podemos acceder a la instancia de la tabla si es necesario
    if (event && event.table) {
      // La tabla se ha cargado exitosamente
      console.log('Tabla cargada:', event.tableId);
    }
  }

  customClick(event: any): void {
    console.log('CustomClick event:', event); // Para debugging
    
    const buttonId = event['button-id'];
    const dataId = event['data-id'];
    
    // Necesitamos obtener los datos de la fila de la tabla
    if (this.dataTableComponent && this.dataTableComponent.dtInstance) {
      const table = this.dataTableComponent.dtInstance;
      const rowData = table.row((idx: any, data: any) => data.Id == dataId).data();
      
      console.log('Row data:', rowData); // Para debugging
      
      switch (buttonId) {
        case 'btnView':
          this.verPlantilla(rowData);
          break;
        case 'btnEdit':
          this.editarPlantilla(rowData);
          break;
        case 'btnDelete':
          this.confirmarEliminarPlantilla(rowData);
          break;
        case 'btnDownload':
          this.descargarPlantilla(rowData);
          break;
        default:
          console.log('Botón no reconocido:', buttonId);
      }
    }
  }

  editarPlantilla(plantilla: any): void {
    this.plantillaEditandoId = plantilla.Id;
    this.archivoEditSeleccionado = null;
    this.formEditSubmitted = false;

    this.plantillasService.obtenerPlantilla(plantilla.Id).subscribe({
      next: (response) => {
        if (response.Ok && response.Data) {
          const data = response.Data;
          this.editarForm.patchValue({
            nombre: data.Nombre ?? data.nombre ?? '',
            descripcion: data.Descripcion ?? data.descripcion ?? '',
            activo: data.Activo ?? data.activo ?? true
          });
          const dialog = document.querySelector('.edit-plantilla');
          this.dialogComponentEdit = new fabric['Dialog'](dialog);
          this.dialogComponentEdit.open();
        } else {
          this.mostrarError('Error al obtener los datos de la plantilla');
        }
      },
      error: (error) => {
        this.mostrarError('Error al obtener plantilla: ' + error.message);
      }
    });
  }

  onArchivoEditSeleccionado(event: any): void {
    const archivo = event.target.files[0];
    this.archivoEditSeleccionado = archivo || null;
  }

  cancelarEdicion(): void {
    this.baseService.triggerShowModal(
      'Cancelar edición',
      '¿Seguro que desea cancelar la edición de la plantilla?',
      ModalNotifyTypes.Warning,
      true
    );

    this.modalNotifyComponent.actionConfirmed.subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.editarForm.reset();
        this.editarForm.controls['activo'].setValue(true);
        this.archivoEditSeleccionado = null;
        this.formEditSubmitted = false;
        this.dialogComponentEdit.close();
      }
    });
  }

  guardarEdicion(): void {
    this.formEditSubmitted = true;

    if (this.editarForm.valid) {
      this.botonProcesando = true;
      this.textoBotonProcesando = 'Guardando...';

      const request: any = {
        id: this.plantillaEditandoId,
        nombre: this.editarForm.get('nombre')?.value,
        descripcion: this.editarForm.get('descripcion')?.value || '',
        activo: this.editarForm.get('activo')?.value
      };

      if (this.archivoEditSeleccionado) {
        this.plantillasService.convertirArchivoABase64(this.archivoEditSeleccionado)
          .then(base64 => {
            request.nombreArchivo = this.archivoEditSeleccionado!.name;
            request.extension = this.archivoEditSeleccionado!.name.split('.').pop()?.toUpperCase() || '';
            request.archivoBase64 = base64;
            this.ejecutarEdicion(request);
          })
          .catch(error => {
            this.mostrarError('Error al procesar archivo: ' + error.message);
            this.botonProcesando = false;
          });
      } else {
        this.ejecutarEdicion(request);
      }
    }
  }

  private ejecutarEdicion(request: any): void {
    this.plantillasService.editarPlantilla(request).subscribe({
      next: (response) => {
        if (response.Ok) {
          this.dialogComponentEdit.close();
          this.mostrarExito('Plantilla actualizada exitosamente');
          this.recargarTabla();
        } else {
          this.mostrarError('Error al actualizar plantilla: ' + (response.Error || response.error || 'Error desconocido'));
        }
        this.botonProcesando = false;
      },
      error: (error) => {
        this.mostrarError('Error al actualizar plantilla: ' + error.message);
        this.botonProcesando = false;
      }
    });
  }

  confirmarEliminarPlantilla(plantilla: any): void {
    this.baseService.triggerShowModal(
      'Eliminar Plantilla',
      `¿Está seguro que desea eliminar la plantilla "${plantilla.Nombre}"?`,
      ModalNotifyTypes.Warning,
      true
    );

    this.modalNotifyComponent.actionConfirmed.subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.eliminarPlantilla(plantilla.Id);
      }
    });
  }

  eliminarPlantilla(id: number): void {
    this.botonProcesando = true;
    this.textoBotonProcesando = 'Eliminando...';

    this.plantillasService.eliminarPlantilla(id).subscribe({
      next: (response) => {
        if (response.Ok) {
          this.mostrarExito('Plantilla eliminada exitosamente');
          this.recargarTabla(); // Usar el método correcto de recarga
        } else {
          this.mostrarError('Error al eliminar plantilla: ' + (response.Error || 'Error desconocido'));
        }
        this.botonProcesando = false;
      },
      error: (error) => {
        this.mostrarError('Error al eliminar plantilla: ' + error.message);
        this.botonProcesando = false;
      }
    });
  }

  descargarPlantilla(plantilla: any): void {
    this.plantillasService.descargarPlantilla(plantilla.Id).subscribe({
      next: (response: Blob) => {
        const url = window.URL.createObjectURL(response);
        const a = document.createElement('a');
        a.href = url;
        a.download = plantilla.Nombre + '.' + plantilla.Extension.toLowerCase();
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        this.mostrarError('Error al descargar plantilla: ' + error.message);
      }
    });
  }

  mostrarExito(mensaje: string): void {
    this.baseService.triggerShowModal(
      'Éxito',
      mensaje,
      ModalNotifyTypes.Success,
      false
    );
  }

  mostrarError(mensaje: string): void {
    this.baseService.triggerShowModal(
      'Error',
      mensaje,
      ModalNotifyTypes.Danger,
      false
    );
  }

  // Métodos del visor de documentos
  verPlantilla(plantilla: any): void {
    this.documentoActual = {
      id: plantilla.Id,
      nombre: plantilla.Nombre || plantilla.NombreArchivo,
      extension: plantilla.Extension
    };
    
    this.mostrarVisor = true;
    this.cargandoDocumento = true;
    
    // Cargar el documento usando los datos ya disponibles
    this.cargarDocumentoVisor(plantilla);
  }

  cargarDocumentoVisor(plantilla: any): void {
    // Obtener URL de visualización del backend
    this.plantillasService.obtenerUrlVisualizacion(plantilla.Id).subscribe({
      next: (response) => {
        if (response.Ok && response.Data && response.Data.UrlVisualizacion) {
          console.log('URL directa para Google Docs:', response.Data.UrlVisualizacion);
          this.crearVisorDocumento(response.Data.UrlVisualizacion);
        } else {
          this.mostrarError('Error al obtener URL de visualización');
          this.cargandoDocumento = false;
        }
      },
      error: (error) => {
        console.error('Error al obtener URL de visualización:', error);
        this.mostrarError('Error al cargar el documento');
        this.cargandoDocumento = false;
      }
    });
  }

  crearVisorDocumento(blobUrl: string): void {
    // Esperar a que Angular renderice el modal
    setTimeout(() => {
      // Crear iframe siguiendo el patrón de visualizadorArchivos existente
      const _extUrl = blobUrl.toLowerCase().replace(/\?.*$/, '');
      let _viewerEl: HTMLElement;
      if (/\.(png|jpe?g|gif|webp|svg|bmp|ico)$/.test(_extUrl)) {
        const img = document.createElement('img');
        img.style.cssText = 'max-width: 100%; max-height: 600px; display: block; margin: auto; padding: 1em;';
        img.src = blobUrl;
        _viewerEl = img;
      } else {
        const iFrame = document.createElement('iframe');
        iFrame.style.cssText = 'width: 100%; height: 600px; border: none;';
        if (/\.(xlsx?|docx?|pptx?|csv)$/.test(_extUrl)) {
          iFrame.src = 'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(blobUrl);
        } else if (/\.(pdf|txt|html?|xml)$/.test(_extUrl)) {
          iFrame.src = blobUrl;
        } else {
          iFrame.src = 'https://docs.google.com/gview?url=' + encodeURIComponent(blobUrl) + '&embedded=true';
        }
        _viewerEl = iFrame;
      }
      
      // Usar ViewChild para acceder al elemento
      if (this.documentContentRef && this.documentContentRef.nativeElement) {
        const documentContent = this.documentContentRef.nativeElement;
        documentContent.innerHTML = "";
        documentContent.style.display = "block";
        // El modal ya muestra 'Cargando documento...' mientras cargandoDocumento=true.
        // Lo apagamos cuando el elemento dispara onload (o tras timeout de seguridad).
        const _fallback = setTimeout(() => { this.cargandoDocumento = false; }, 30000);
        (_viewerEl as any).onload = () => { clearTimeout(_fallback); this.cargandoDocumento = false; };
        documentContent.appendChild(_viewerEl);
      } else {
        console.error('No se pudo encontrar el elemento documentContent');
        this.cargandoDocumento = false;
      }
    }, 1000); // Dar tiempo para que el modal se renderice
  }

  cerrarVisor(): void {
    this.mostrarVisor = false;
    this.cargandoDocumento = false;
    
    // Limpiar el contenido del documento
    if (this.documentContentRef && this.documentContentRef.nativeElement) {
      const documentContent = this.documentContentRef.nativeElement;
      documentContent.innerHTML = "";
      documentContent.style.display = "none";
    }
    
    // Resetear datos del documento
    this.documentoActual = {
      id: 0,
      nombre: '',
      extension: ''
    };
  }

  descargarDocumento(idPlantilla: number): void {
    // Usar el método de descarga existente
    this.plantillasService.descargarPlantilla(idPlantilla).subscribe({
      next: (response: Blob) => {
        const url = window.URL.createObjectURL(response);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.documentoActual.nombre + '.' + this.documentoActual.extension.toLowerCase();
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        this.mostrarError('Error al descargar documento: ' + error.message);
      }
    });
  }

  getContentType(extension: string): string {
    const ext = extension.toLowerCase();
    const contentTypes: { [key: string]: string } = {
      'pdf': 'application/pdf',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'ppt': 'application/vnd.ms-powerpoint',
      'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'txt': 'text/plain',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'png': 'image/png',
      'gif': 'image/gif'
    };
    
    return contentTypes[ext] || 'application/octet-stream';
  }

  private getFileExtension(filename: string): string {
    return filename.split('.').pop()?.toLowerCase() || '';
  }
}
